import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-politicas',
  templateUrl: './politicas-privacidad.component.html'
})


export class PoliticasComponent implements OnInit {
  ngOnInit(): void { }
}
